import { useRef, useState } from "react";

export function InputMD(props: React.InputHTMLAttributes<HTMLInputElement>) {
  const inputRef = useRef<HTMLInputElement>(null);
  const [copied, setCopied] = useState(false);
  const value = props.value ? props.value.toString() : "";
  const handleCopy = async () => {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      try {
        await navigator.clipboard.writeText(value); // Копирование через Clipboard API
        setCopied(true);
        setTimeout(() => setCopied(false), 1500);
      } catch (err) {
        console.error("Ошибка копирования: ", err);
      }
    } else {
      if (inputRef.current) {
        inputRef.current.value = value; // Обновляем значение на случай ошибок
        inputRef.current.focus();
        inputRef.current.setSelectionRange(0, value.length); // Выделение
        document.execCommand("copy"); // Старый метод копирования (iOS 12-)
        inputRef.current.blur();
        setCopied(true);
        setTimeout(() => setCopied(false), 1500);
      }
    }
  };

  return (
    <div
      style={{
        position: "relative",
        display: "inline-block",
        width: "100%",
        marginTop: 10,
      }}
    >
      <input
        ref={inputRef}
        value={props.value}
        readOnly
        style={{
          color: copied ? "#fff" : "#999",
          background: copied ? "#28a745" : "#1c1a18",
          border: "1px solid #3b3734",
          borderRadius: 5,
          outline: "none",
          width: "100%",
          height: 32,
          padding: "0 40px 0 8px",
          fontSize: 13,
          lineHeight: "32px",
          display: "block",
          transition: "background 0.3s, color 0.3s",
        }}
      />
      <button
        onClick={handleCopy}
        style={{
          position: "absolute",
          right: 5,
          top: "50%",
          transform: "translateY(-50%)",
          background: copied ? "#28a745" : "#333",
          color: "#fff",
          border: "none",
          borderRadius: 3,
          padding: "4px 8px",
          cursor: "pointer",
          fontSize: 12,
          transition: "background 0.3s",
        }}
      >
        {copied ? "✔️ Скопировано!" : "📋"}
      </button>
    </div>
  );
}
